import {
  FETCH_TEMPLATES_PREVIEW_START,
  FETCH_TEMPLATES_PREVIEW_FAIL,
  WRITE_TEMPLATE_PREVIEW_START,
  WRITE_TEMPLATE_PREVIEW_FAIL,
  DELETE_TEMPLATE_PREVIEW_START,
  DELETE_TEMPLATE_PREVIEW_SUCCESS,
  DELETE_TEMPLATE_PREVIEW_FAIL,
  FETCH_TEMPLATES_PREVIEW_ALL_SUCCESS,
  UPDATE_TEMPLATES_PREVIEW_POSITIONS,
} from './action';

const initialState = {
  isLoading: true,
  isInitial: false,
  err: null,
  data: [],
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
  case FETCH_TEMPLATES_PREVIEW_START:
  case WRITE_TEMPLATE_PREVIEW_START:
  case DELETE_TEMPLATE_PREVIEW_START:
    return {
      ...state,
      isLoading: true,
      isInitial: true,
    };

  case FETCH_TEMPLATES_PREVIEW_ALL_SUCCESS:
    return {
      ...state,
      data: payload,
      isLoading: false,
      isInitial: true,
    };

  case DELETE_TEMPLATE_PREVIEW_SUCCESS:
    return {
      ...state,
      data: state.data.filter((item) => item.id !== payload),
      isLoading: false,
    };

  case UPDATE_TEMPLATES_PREVIEW_POSITIONS:
    return {
      ...state,
      data: payload.items
    };

  case FETCH_TEMPLATES_PREVIEW_FAIL:
  case WRITE_TEMPLATE_PREVIEW_FAIL:
  case DELETE_TEMPLATE_PREVIEW_FAIL:
    return {
      ...state,
      err: payload,
      isLoading: false,
      isInitial: true,
    };

  default:
    return { ...state };
  }
};
